import React from 'react';
import styles from './self-initiated-verification-bottomsheet.module.scss';
import { BottomSheet, Button, Typography } from '@/ui-kit';
import { OkHandIcon, VerificationIcon, VerifiedAccountIcon } from '@/assets/icons';
import { useAuth } from '@/store/useAuth';
import WebApp from '@twa-dev/sdk';
import { Trans, useTranslation } from 'react-i18next';

interface Props {
    isVerificationModalOpen: boolean;
    setIsVerificationModalOpen: (val: boolean) => void;
    onOkClicked?: () => Promise<boolean>;
}

export const SelfInitiatedVerificationBottomsheet: React.FC<Props> = ({
    isVerificationModalOpen,
    setIsVerificationModalOpen,
    onOkClicked,
}) => {
    const userData =
        useAuth((state) => state.getUser());

    const { t } = useTranslation();

    const handleBtnClick = async () => {
        if (onOkClicked) {
            const isSuccess = await onOkClicked?.()
            if (!isSuccess) return
        }
        const { id, public_name } = userData ?? {};
        const params = new URLSearchParams({
            text: t('verification_msg', { name: public_name, id })
        });

        WebApp.openTelegramLink(`https://t.me/euphora_support?${params}`);

        setIsVerificationModalOpen(false)
    }
    
    return (
        <BottomSheet
            isOpen={isVerificationModalOpen}
            isDeskorTop={false}
            onClose={() => setIsVerificationModalOpen(false)}
            className={styles.bottomsheet}
            overlayClassName={styles.bottomsheetOverlay}>
            <div className={styles.verificationModalContent}>
                <VerificationIcon className={styles.verificationModalContentIcon} />
                <div className={styles.verificationModalContentHeader}>
                    <Typography
                        className={styles.verificationModalContentHeaderTitle}
                        variant={'h5'}
                        fontWeight={'bold'}>
                        <Trans
                            i18nKey="profile.verification_status_note"
                            values={{ iconLabel: t('profile.icon') }}
                            components={[
                                <span className={styles.iconWrapper}>
                                    <VerifiedAccountIcon width={20} height={20} />
                                </span>
                            ]} />
                    </Typography>
                    <Typography
                        className={styles.verificationModalContentHeaderDesc}>
                        <Trans i18nKey={'profile.verification_action_tertiary'} />
                    </Typography>
                    <OkHandIcon width={40} height={40} />
                </div>
                <div className={styles.verificationModalContentFootnote}>
                    <Typography className={styles.verificationModalContentFootnoteTitle}>
                        {t('profile.verification_action_secondary')}
                    </Typography>
                    <Typography
                        className={styles.verificationModalContentFootnoteSubtitle}>
                        {t('video_not_shared')}
                    </Typography>
                    <div className={styles.verificationModalContentFootnoteBtns}>
                        <Button
                            typeColor="orange"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={handleBtnClick}>
                            {t('start_verification')}
                        </Button>
                        <Button
                            typeColor="white"
                            textColor="black"
                            className={styles.verificationModalContentFootnoteBtn}
                            onClick={() => setIsVerificationModalOpen(false)}>
                            {t('profile.later')}
                        </Button>
                    </div>
                </div>
            </div>
        </BottomSheet>
    );
};
